import type { ReactNode } from 'react';

import { cn } from '@/lib/utils';

interface GeneralErrorIndicatorProps {
  children: ReactNode;
  className?: string;
}

export function GeneralErrorIndicator({ children, className }: GeneralErrorIndicatorProps) {
  return (
    <div
      className={cn('rounded-lg border border-red-200 bg-red-50 p-4', className)}
      role="alert"
      aria-live="polite"
    >
      <p className="text-sm text-red-800">{children}</p>
    </div>
  );
}
